import React, {Fragment} from 'react'

const GalleryVideos = ({data}) => {
  return (
    <Fragment>

<div className="row">
              {data.GS_Image_Array.map((item,index) => (
                            <div key={index} className="col-lg-6">

  <div  className={`image mb-30 wow fadeInUp delay-0-${2+index*2}s`}>
  <video
  autoPlay
  playsInline
  className='portfolio-video-section'
  muted
  loop
    src={item}
    alt={`portfolio showcase ${index}`}
  />
</div>
</div>

              ))}
            

          </div>

    </Fragment>
  )
}

export default GalleryVideos;